__turbopack_context__.v({
  "appear-slide-left": "ReviewSwiper-module-scss-module__TIUv4q__appear-slide-left",
  "author": "ReviewSwiper-module-scss-module__TIUv4q__author",
  "bounceTwice": "ReviewSwiper-module-scss-module__TIUv4q__bounceTwice",
  "comment": "ReviewSwiper-module-scss-module__TIUv4q__comment",
  "fade-in-bottom": "ReviewSwiper-module-scss-module__TIUv4q__fade-in-bottom",
  "fade-in-left": "ReviewSwiper-module-scss-module__TIUv4q__fade-in-left",
  "fade-in-right": "ReviewSwiper-module-scss-module__TIUv4q__fade-in-right",
  "fadeIn": "ReviewSwiper-module-scss-module__TIUv4q__fadeIn",
  "loader": "ReviewSwiper-module-scss-module__TIUv4q__loader",
  "puff-in-center": "ReviewSwiper-module-scss-module__TIUv4q__puff-in-center",
  "puff-in-left": "ReviewSwiper-module-scss-module__TIUv4q__puff-in-left",
  "pulse": "ReviewSwiper-module-scss-module__TIUv4q__pulse",
  "pulse-contact": "ReviewSwiper-module-scss-module__TIUv4q__pulse-contact",
  "reviewCard": "ReviewSwiper-module-scss-module__TIUv4q__reviewCard",
  "shake-bottom": "ReviewSwiper-module-scss-module__TIUv4q__shake-bottom",
  "slide-again": "ReviewSwiper-module-scss-module__TIUv4q__slide-again",
  "slide-in-right": "ReviewSwiper-module-scss-module__TIUv4q__slide-in-right",
  "stepContent-entrance": "ReviewSwiper-module-scss-module__TIUv4q__stepContent-entrance",
});
